import { Delete } from "lucide-react";

export default function PinPad({ value, onChange, length = 4, disabled = false }) {
  const press = (d) => {
    if (disabled || value.length >= length) return;
    onChange(value + d);
  };
  const back = () => {
    if (disabled) return;
    onChange(value.slice(0, -1));
  };

  const keys = ["1","2","3","4","5","6","7","8","9","","0","back"];

  const renderKey = (k) => {
    if (k === "") return <div key="empty" />;
    if (k === "back") {
      return (
        <button
          key="back"
          type="button"
          data-testid="pin-pad-backspace-button"
          onClick={back}
          className="h-16 rounded-2xl bg-[#FAF6F0] border border-[#E4DDD3] text-slate-600 grid place-items-center active:scale-95 transition-transform"
        >
          <Delete className="w-6 h-6" />
        </button>
      );
    }
    return (
      <button
        key={k}
        type="button"
        data-testid={`pin-pad-button-${k}`}
        onClick={() => press(k)}
        className="h-16 rounded-2xl bg-[#FAF6F0] border border-[#E4DDD3] text-2xl font-mono font-bold text-[#1A1D20] active:scale-95 active:bg-[#FDF0EB] active:border-terra-400/50 transition-all"
      >
        {k}
      </button>
    );
  };

  return (
    <div className="w-full max-w-xs mx-auto" data-testid="pin-pad">
      <div className="flex justify-center gap-4 mb-6" data-testid="pin-dots">
        {Array.from({ length }).map((_, i) => (
          <div
            key={`dot-${i}`}
            className={`pin-dot w-4 h-4 rounded-full border-2 border-terra-400/60 ${i < value.length ? "filled" : "bg-transparent"}`}
          />
        ))}
      </div>
      <div className="grid grid-cols-3 gap-3">
        {keys.map(renderKey)}
      </div>
    </div>
  );
}
